import { a as __rest } from '../../../tslib.es6.esm.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useId, useCallback } from 'react';
import { ExclamationCircleIcon } from '@iris/react-icons/ExclamationCircleIcon';
import { BaseInput } from '../../BaseInput/BaseInput.esm.js';
import { BaseLabel } from '../../BaseLabel/BaseLabel.esm.js';
import { InlineMessage } from '../../InlineMessage/InlineMessage.esm.js';
import { useSliderA11y } from '../context/SliderA11yProvider.esm.js';
import inputStyles from './SliderSingleInput.styles.esm.js';
import { cn } from '../../../utils/cn.esm.js';

const SingleSliderInput = forwardRef((props, ref) => {
    const generatedId = useId();
    const { isSliderFocused, setSingleInputRef } = useSliderA11y();
    const { id = generatedId, label = "", error, errorMessage, helperText = true, helperTextMessage = "", disabled, className, min, max, inverse = false, value, onChange, onBlur } = props, otherProps = __rest(props, ["id", "label", "error", "errorMessage", "helperText", "helperTextMessage", "disabled", "className", "min", "max", "inverse", "value", "onChange", "onBlur"]);
    const { input: inputClasses, label: labelClasses, errorMessage: errorClasses, helperText: helperTextClasses, inputContainer: inputContainerClasses, labelContainer: labelContainerClasses, wrapper: wrapperClasses, inlineMessage: inlineMessageClasses, } = inputStyles({
        inverse,
        error,
        disabled,
    });
    const ariaDescribedBy = [errorMessage && `${id}-error`, helperTextMessage && `${id}-helper-text`]
        .filter(Boolean)
        .join(" ") || undefined;
    const setMergedRef = useCallback((node) => {
        setSingleInputRef(node);
        if (typeof ref === "function")
            ref(node);
        else if (ref)
            ref.current =
                node;
    }, [ref, setSingleInputRef]);
    return (jsxs("div", { className: wrapperClasses(), children: [jsxs("div", { className: inputContainerClasses(), children: [jsx("div", { className: labelContainerClasses(), children: label && (jsx(BaseLabel, { id: `${id}-label`, htmlFor: id, inverse: inverse, disabled: disabled, className: labelClasses(), children: label })) }), jsx(BaseInput, Object.assign({ id: id, ref: setMergedRef, inverse: inverse, disabled: disabled, "aria-describedby": ariaDescribedBy, className: cn(inputClasses(), className), value: value, onChange: onChange, onBlur: onBlur }, otherProps, { "aria-hidden": isSliderFocused || undefined, tabIndex: isSliderFocused ? -1 : undefined }))] }), error && errorMessage && (jsx(InlineMessage, { id: id, disabled: disabled, className: inlineMessageClasses(), icon: jsx(ExclamationCircleIcon, {}), iconClass: cn(errorClasses(), "iris:self-start"), label: errorMessage, labelClass: errorClasses() })), helperText && (jsx("span", { id: `${id}-helper-text`, className: helperTextClasses(), children: helperTextMessage }))] }));
});
SingleSliderInput.displayName = "SingleSliderInput";

export { SingleSliderInput };
